module.exports = __webpack_public_path__ + "static/media/fourth.bdb20005.jpg";